'use client';

import { c as _c } from "react/compiler-runtime";
import { motion, useReducedMotion } from 'framer-motion';
import { useState, useSyncExternalStore } from 'react';
import SmallLogo from '@/assets/svgs/small_logo.svg';
import { STORAGE_KEY } from '@/constants/storage-key';
const ENTER_SECONDS = 0.25;
const HOLD_SECONDS = 2;
const EXIT_SECONDS = 0.3;
const TOTAL_SECONDS = ENTER_SECONDS + HOLD_SECONDS + EXIT_SECONDS;
const subscribe = () => () => {};
const getServerSnapshot = () => false;

//* 앱 스킴 복귀·결제 복귀·새로고침은 전체 리로드라 마운트만으로는 "최초 진입"을 구분할 수 없다
const getClientSnapshot = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY.KAKAOBANK_ENTRY_TOAST_SHOWN) !== 'true';
  } catch {
    return true;
  }
};
const markShown = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY.KAKAOBANK_ENTRY_TOAST_SHOWN, 'true');
    return true;
  } catch {
    return false;
  }
};

//* 카뱅 제휴사 가이드 「Toast」 — 등장 250ms · 노출 2초 · 퇴장 300ms를 한 타임라인으로 돌리고 끝나면 내린다
export const KakaobankEntryToast = () => {
  const $ = _c(11);
  const isFirstEntry = useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot);
  const [isDone, setIsDone] = useState(false);
  const shouldReduceMotion = useReducedMotion();
  if (!isFirstEntry || isDone) {
    return null;
  }
  const restY = shouldReduceMotion ? 8 : 0;
  let t0;
  if ($[0] !== restY) {
    t0 = {
      opacity: 0,
      y: restY
    };
    $[0] = restY;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [0, 1, 1, 0];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== restY) {
    t2 = {
      opacity: t1,
      y: [restY, 8, 8, restY]
    };
    $[3] = restY;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      duration: TOTAL_SECONDS,
      times: [0, ENTER_SECONDS / TOTAL_SECONDS, (ENTER_SECONDS + HOLD_SECONDS) / TOTAL_SECONDS, 1],
      ease: ["easeOut", "linear", "easeIn"]
    };
    t4 = () => {
      markShown();
      setIsDone(true);
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="grid size-22 shrink-0 place-items-center rounded-pill bg-Gray-white text-Gray-black"><SmallLogo aria-hidden={true} className="h-10 w-14" /></span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t0 || $[9] !== t2) {
    t6 = <motion.div role="status" initial={t0} animate={t2} transition={t3} onAnimationComplete={t4} className="pointer-events-none fixed inset-x-0 top-0 z-30 mx-auto flex w-fit items-center gap-4 whitespace-nowrap rounded-pill bg-Gray-black py-12 pl-12 pr-16 text-[0.9375rem] font-700 leading-[1.2] text-Gray-white drop-shadow-[1px_1px_3px_rgba(0,0,0,0.24)]">{t5}웰로로 이동했어요</motion.div>;
    $[8] = t0;
    $[9] = t2;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};